import "./docs_perms.css"
import React, {useMemo, useState, useEffect} from 'react';
import Form from 'react-bootstrap/Form'
import MenuItem from '@mui/material/MenuItem';
import Checkbox from "@mui/material/Checkbox";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Select from '@mui/material/Select';
import {makeStyles} from '@mui/styles';


const useStyles = makeStyles((theme) => ({
    indeterminateColor: {
      color: "#f50057"
    },
    selectAllText: {
      fontWeight: 500
    },
    selectedAll: {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.08)"
      }
    },
    input: {
        display: 'none',
      },
      container: {
        maxHeight: 440,
      },
      select: {
        "&:focus": {
          backgroundColor: "white",
          borderBottomWidth: 0
        }
      },
      selectInput: {
        "&:hover:not($disabled):not($focused):not($error):before": {
          borderBottomWidth: 0
        },
        "&:focus": {
            backgroundColor: "white",
            borderBottomWidth: 0
          },
        "&:not($disabled):not($focused):not($error):before": {
          borderBottomWidth: 0,
          borderWidth:1
        }
      },
      disabled: {},
      focused: {},
      error: {}
  }));


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    variant: "menu"
  };




export default function Docs_perms({ permission_selected, setpermission_selected }) {
    const classes = useStyles();

    const [users, setusers] = useState([
        {
            role:0,
            user:"Fournisseur"
        },
        {
            role:1,
            user:"Service d'achat"
        },
        {
            role:2,
            user:"Service métier"
        },
        {
            role:3,
            user:"Service de finance"
        }
    ]);
    const [selected, setSelected] = useState([]);
    const [selectedId, setSelectedId] = useState([]);


    useEffect(()=>{
        let tmp_array = [];
        users.map((user) => {
            permission_selected.map((permission_userRole)=>{
                if(user.role === permission_userRole) tmp_array.push(user.user);
            });
        });
        setSelected(tmp_array);
        setSelectedId(permission_selected);
    },[])

    function user_role_by_name(sld_users){
        let id=[];
        users.map((user) => {
         sld_users.map((sld_user) => {
            if(user.user === sld_user) id.push(user.role);
          });
        });
        return id;
      }

    const handleChange = (event) => {
        const value = event.target.value;
        if (value[value.length - 1] === "all") {
            let tmp_array = [];
            let tmp_id_array = [];
            users.map((user) => {
                tmp_array.push(user.user);
                tmp_id_array.push(user.role);
            })
            setSelected(selected.length === users.length ? [] : tmp_array);
            setSelectedId(selected.length === users.length ? [] : tmp_id_array);
            setpermission_selected(selected.length === users.length ? [] : tmp_id_array);
            return;
        }
        setSelected(value);
        setSelectedId(user_role_by_name(value));
        setpermission_selected(user_role_by_name(value));
    };

    const isAllSelected = useMemo(() => users.length > 0 && selected.length === users.length,[selected]);


  return (
    <div className="docs_perms">
      <div style={{marginBottom:'10px'}}>
        Par défaut, tous les utilisateurs du système n'ont pas l'autorisation de modifier le document, les utilisateurs ajoutés à la liste ci-dessous auront cette autorisation.
      </div>
      <div>
      <Form.Group className="col-md-12">
            <Select
                labelId="mutiple-select-label"
                multiple
                value={selected}
                onChange={handleChange}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
                className="form-control form-select form-select-control"
            >
            <MenuItem
                value="all"
                primaryText="all"
                classes={{
                    root: isAllSelected ? classes.selectedAll : ""
                }}
                >
                <ListItemIcon>
                    <Checkbox
                    classes={{ indeterminate: classes.indeterminateColor }}
                    checked={isAllSelected}
                    indeterminate={
                        selected.length > 0 && selected.length < users.length
                    }
                    />
                </ListItemIcon>
                <ListItemText
                    classes={{ primary: classes.selectAllText }}
                    primary="Tout sélectionner"
                />
            </MenuItem>

            {
                users.map((user)=>(
                    <MenuItem key={user.user} value={user.user} primaryText={user.user}>
                        <ListItemIcon>
                            <Checkbox checked={selected.indexOf(user.user) > -1} />
                        </ListItemIcon>
                        <ListItemText primary={user.user} />
                    </MenuItem> 
                ))
            }
            
        </Select>        
    </Form.Group>
      </div>
    </div>
  );
}
